import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {connect} from 'react-redux'
import { BLTNavigationTop, BLTScreenNavigation } from '../BLTCommon/BLTNavigationTop';
import { 
    bltChangeReviewSelect
} from '../../../redux/selector/bltChangeReviewSelector'
import "./BLTChangeReview.styles.scss"
import { fetchApplicationWithId, sendNewIndividualApplicationStatus, sendRenewedIndividualApplicationStatus } from '../../../redux/slice/bltHomeSlice';
import { setChangeReviewQueueItem } from '../../../redux/slice/bltChangeReviewSlice';
import * as CONST from '../../../app/constants';
import { 
    combineAddress, 
    decideLegalAndOperatingNames, 
    decideRegistryId, 
    fullName, 
    humanReadableDateTime 
} from '../../../app/utils';
import { useParams } from 'react-router-dom';
import BLTChangeReviewForm from '../../../components/ReviewForm/BLTChangeReviewForm';
import ReviewForm from '../../../components/ReviewForm/BLTReviewForm'
import { setAgencyApplicationLicenceStatus, setAgencyApplicationLocked, setAgencyApplicationStatus, setInternalNoteList } from '../../../redux/slice/primaryAgencyApplicationSlice';
import { setCurrentAgentApplicationLocked, setCurrentAgentApplicationStatus, setCurrentAgentLicenceStatus } from '../../../redux/slice/additionalApplicationsSlice';
import { Button, ErrorMark } from '../../../components/RegularComponents';
import { push } from 'connected-react-router';
import { saveBusinessLicenceApplicationData } from '../../../redux/slice/businessLicenceApplicationSlice';
import { legalNameTitle, mainTitle, mediumTitle, subTitle } from '../BLTReview/BLTReviewUtils';
import { 
    parseCriminalHistory,
    parseLicenceSuspension,
    parseDocumentsData,
} from '../../../redux/selector/bltReviewSelector';
import { DocumentViewerFileNameLink, DownloadFileNameLink } from '../../../components/DocumentViewer/DocumentFileComponent';
import { convertFileDataForUrl } from '../../../app/documentUploadUtils';
import { fetchDocumentData } from '../../../redux/slice/supportingDocumentsSlice';
import DocumentViewer from '../../../components/DocumentViewer/DocumentViewer';
import { applicationTypeFromLicenceSubType, isAgencyTypeApplication, isIndividualTypeApplication, isRenewalTypeApplication } from '../../../redux/slice/applicationsUtils';
import { parseAdditionalBranchesData } from '../../../redux/selector/BLTReviewData/collectionsReviewData';
// import { fetchArchiveApplicationsForOriginalId } from '../../../redux/slice/archiveApplicationsSlice';

const BLTChangeReview = (props) => {
    
    const {bltChangeReview, dispatch} = props
    const {
        queueItem, 
        archiveApplication, 
        additionalBranchApplications,
        branchArchiveApplications, 
        agentApplications,
        userData 
    } = bltChangeReview
    let { qItemId } = useParams();

    const [applicationDecision,setApplicationDecision] = useState(CONST.APPLICATION_STATUS_PENDING)
    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)
    const [validationError, setValidationError] = useState(null)
    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
    const [internalNotesText, setInternalNotesText] = useState("")
    const [sectionShown, setSectionShown] = useState({})

    const isReadOnly = useMemo(() => {
        let isReadOnly = false

        if(queueItem?.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED
            || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_DENIED
            || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
            || queueItem?.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) 
        { 
            isReadOnly = true
        }
        else if(queueItem
                && queueItem.locked 
                && (queueItem.locked 
                !== (userData?.email)))
        {
            isReadOnly = (queueItem.applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW || 
                queueItem.applicationStatus === CONST.APPLICATION_STATUS_PENDING)
        }
        return isReadOnly 
     }, [queueItem, userData])

    const onReviewStatusChange = (key, updatedItem) => {
        // console.log({key})
        // console.log({updatedItem})
    }

    const internalNotes = useMemo(() => queueItem?.businessLicenceData?.internalNoteList?.length > 0 ? queueItem.businessLicenceData.internalNoteList : [], [queueItem?.businessLicenceData?.internalNoteList])

    const expandSection = (section, toggle) => { 
        setSectionShown((prevSection) => ({...prevSection, [section]: toggle }))
    }

    const SubSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{borderColor : "#777", borderWidth: '1px'}} 
            />
        )
    }

    const MainSeparator = () => {
        return(
            <hr
                className="bottomMarginNormal"
                style={{borderColor : "#777", borderWidth: '3px'}} 
            />
        )
    }

    const sectionNameMappings = {
        "applicantInformation" : {
            title : "Applicant Information",
            type : "diff_review"
        },
        "criminalHistoryData" : {
            title : "Criminal history",
            type : "review"
        },
        "licenceSuspendedData" : {
            title : "Licence suspension",
            type : "review"
        },
        "attachments" : {
            title : "Application attachments",
            type : "review"
        },
        "individualApplicationsForRenewal" : {
            title : "Renewed collectors",
            type : "review"
        },
        "suretyBond" : {
            title : "Surety bond",
            type : "review"
        },
        "branches" : {
            title : "Additional branches",
            type : "review"
        },
        "internalNotes" : {
            title : "Internal notes",
            type : "review"
        }
    }

    const mergeKeys = (obj1, obj2) => {
        const obj1Keys = Object.keys(obj1)
        const obj2Keys = Object.keys(obj2)
        
        const mergedKeys = []

        for (let index = 0; index < Math.max(obj1Keys.length, obj2Keys.length); index++) {

            if (index < obj1Keys.length && (mergedKeys.indexOf(obj1Keys[index]) === -1)) { 
                mergedKeys.push(obj1Keys[index])
            }
            
            if (index < obj2Keys.length && (mergedKeys.indexOf(obj2Keys[index]) === -1)) { 
                mergedKeys.push(obj2Keys[index])
            }
        }

        return mergedKeys
    }

    const applicantInformationFromData = (appData) => {
        const {legalName, operatingName} = decideLegalAndOperatingNames(appData.companyRjscDetails)
        return {
            registryId : decideRegistryId(appData.companyRjscDetails),
            legalName : legalName,
            compnayTrademark : appData.companyTrademark,
            operatingName : operatingName,
            businessAddress : combineAddress(appData.companyRjscDetails?.businessContact?.civicAddress),
            serviceAddress : combineAddress(appData.serviceCivicAddress),
            financialAddress : combineAddress(appData.financialRecordsLocation),
            rjscOfficials : appData.companyRjscDetails?.businessData?.peopleList?.map(p => fullName(p)).join(","),
            emailAddress : appData.mainBusinessContact?.emailAddress ?? "",
            complianceOfficer : fullName(appData.complianceOfficer),
            mainBusinessContact : fullName(appData.mainBusinessContact),
            responsibleAgent : fullName(appData.responsibleAgent)
        }
    }

    const parseBranchDetails = useCallback(() => {
        return additionalBranchApplications.filter(branchApp => {
            return ((branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                    || branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL)
                    && (branchApp.licenceStatus === CONST.LICENCE_STATUS_ACTIVE 
                        || branchApp.licenceStatus === CONST.LICENCE_STATUS_NEW)
                    && (branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD
                        || branchApp.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED))
        })
    }, [additionalBranchApplications])


    const internalNotesSectionComponents = (sectionKey, item) => {
        return (
            <div className="decisionFormItem" key={`${sectionKey}-${queueItem.id}`}>
                <div className="internalNotesFormItem">
                    <div style={{color: "#555", fontWeight: "bold", fontSize: "1em"}}>
                        Internal notes won't be shared with the client but will be saved on the client record
                    </div>
                    <div className="textarea fw-35 bottomMarginNormal">
                        <textarea
                            className="ns-input"
                            id={`blt-review-internalnotes-textarea-${queueItem.id}`}
                            key={`${sectionKey}-${queueItem.id}`}
                            rows={5} 
                            cols={80}
                            value={internalNotesText ?? ""}
                            maxLength={5000}
                            onInput={(e) => {
                                setInternalNotesText(e.target.value)                               
                            }}
                        />
                    </div>
                    <div className="bottomMarginNormal">
                        <Button 
                            id="blt-review-internalnotes-save-button"
                            buttonType="regular_success" 
                            text="Save" 
                            onClick={() => {
                                const newNote = { note: internalNotesText, changeType: "SAVE", internalNoteCategory: "InformationMap" };
                                const newNotes = [...internalNotes, newNote];
                                dispatch(setInternalNoteList(newNotes))
                                // onReviewStatusChange(sectionKey, { 
                                //     ...item,
                                //     review: "complete"
                                // })
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    const changeData = useMemo(() => {
        if(!queueItem || !queueItem.businessLicenceData) 
            return []
        else if(!archiveApplication || !archiveApplication.businessLicenceData) 
            return []
        
        const renewedAgents = agentApplications.filter(app => (
            isRenewalTypeApplication(app) && 
            (app.applicationStatus === CONST.APPLICATION_STATUS_UNREAD ||
            app.applicationStatus === CONST.APPLICATION_STATUS_OPENED ||
            app.applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW)
        ))

        const changesToReview = {}
        const changeToJson = {
            applicantInformation : applicantInformationFromData(queueItem.businessLicenceData),
            criminalHistoryData : parseCriminalHistory(queueItem.businessLicenceData),
            licenceSuspendedData : parseLicenceSuspension(queueItem.businessLicenceData),
            branches : parseBranchDetails(),
            attachments : parseDocumentsData(queueItem.documents ?? []),
            individualApplicationsForRenewal : [{"Collectors" : renewedAgents.map(app => app.contactName).join("\n"), "review" : ""}],
            suretyBond : parseDocumentsData(queueItem.documents ?? []),
            internalNotes : []
        }
        const changeFromJson = {
            applicantInformation : applicantInformationFromData(archiveApplication.businessLicenceData),
            criminalHistoryData : [],
            licenceSuspendedData : [],
            branches : [],
            attachments : [],
            individualApplicationsForRenewal : [],
            suretyBond : [],
            internalNotes : []
        }

        const sectionMaps = [
            "applicantInformation",
            "criminalHistoryData",
            "licenceSuspendedData",
            "branches",
            "attachments",
            "individualApplicationsForRenewal",
            "suretyBond",
            "internalNotes",
        ]
        //const sections = mergeKeys(archiveApplication.businessLicenceData, queueItem.businessLicenceData)
        sectionMaps.forEach(section => {

            if(!changesToReview[section]) { 
                changesToReview[section] = []
            }

            if(section !== "applicantInformation") {
                changesToReview[section].push(...changeToJson[section])
            } else {
                let changeFromObj = {}
                let changeToObj = {}
    
                if (changeFromJson[section]) { 
                    changeFromObj = changeFromJson[section]
                }
    
                if(changeToJson[section]) { 
                    changeToObj = changeToJson[section]
                }
    
                let parameters = []
    
                // assuming the fromElement and toElement are having same type.
                if(Array.isArray(changeFromObj) && Array.isArray(changeToObj)) {
                    
                    for (let index = 0; index < Math.max(changeFromObj.length,changeToObj.length); index++) {
                        let from = {}
                        let to = {}
                        const parameterChangesArray = []
    
                        if(index < changeFromObj.length) 
                            from = changeFromObj[index]
    
                        if(index < changeToObj.length) 
                            to = changeToObj[index]
                        
                        parameters = mergeKeys(from, to)
    
                        parameters.forEach(key => {
                            let fromElement = ""
                            let toElement = ""
    
                            const formatProperty = (key, property) => {
                                let formattedProperty = property
                                if(key === "people" && typeof property !== "string") { 
                                    const name = fullName(property)
                                    const position = property["position"] ?? ""
                                    formattedProperty = [name, position].join(" - ")
                                } else if(key === "dateOfOffence" || key === "suspensionDate") { 
                                    formattedProperty = humanReadableDateTime(property)
                                }
    
                                return formattedProperty
                            }
        
                            if (Object.hasOwnProperty.call(from, key)) {
                                fromElement = formatProperty(key, from[key]);
                            }
        
                            if(Object.hasOwnProperty.call(to, key)) { 
                                toElement = formatProperty(key,to[key])
                            }
        
                            if(fromElement || toElement) { 
                                parameterChangesArray.push({
                                    parameterName : key,
                                    changeFrom : fromElement,
                                    changeTo : toElement,
                                    review : null,
                                })
                            }
                        })
    
                        changesToReview[section].push(parameterChangesArray)
                    }
                } else if(typeof changeFromObj === 'object' 
                        && typeof changeToObj === 'object') {
                    parameters = mergeKeys(changeFromObj, changeToObj)
    
                    parameters.forEach(key => {
                        let fromElement = ""
                        let toElement = ""
    
                        if (Object.hasOwnProperty.call(changeFromObj, key)) {
                            fromElement = changeFromObj[key];
                        }
    
                        if(Object.hasOwnProperty.call(changeToObj, key)) { 
                            toElement = changeToObj[key]
                        }
    
                        changesToReview[section].push({
                            parameterName : key,
                            changeFrom : fromElement,
                            changeTo : toElement,
                            review : null,
                        })
                    })
                }
            }
        })

        return changesToReview
    }, [
        queueItem, 
        archiveApplication,
        agentApplications,
        parseBranchDetails
    ])

    const documentComponent = (d) => { 
        return (
            <>
                { d.documentContentType === CONST.DOCUMENT_CONTENT_TYPE_PDF ? 
                    <DocumentViewerFileNameLink
                        id={"blamin-review-file-" + d.filename.toLowerCase().replace(/ +/g,'_')}
                        key={"blamin-review-file-" + d.filename.toLowerCase().replace(/ +/g,'_')}
                        file={d} 
                        onClick={() => {
                            if(d.data) { 
                                let fileDataUrl = convertFileDataForUrl(d.data, d.documentContentType)
                                setDocumentViewerDocument(fileDataUrl)
                                setOpenDocumentViewer(true)
                                setSelectedFile(d)
                            } else { 
                                // download data and then view it.
                                if(d.guid) { 
                                    dispatch(fetchDocumentData(d.guid))
                                        .then(downloadFile => {
                                            if(downloadFile) {
                                                let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                setDocumentViewerDocument(fileDataUrl)
                                                setOpenDocumentViewer(true)
                                                setSelectedFile(downloadFile)
                                            }
                                        })
                                        .catch((error) => {
                                            console.error(error)
                                        })
                                }
                            }
                        }}
                    /> : 
                    <DownloadFileNameLink
                        id={"bladmin-review-download-file-" + d.filename.toLowerCase().replace(/ +/g,'_')}
                        componentKey={"bladmin-review-download-file-" + d.filename.toLowerCase().replace(/ +/g,'_')}
                        file={d} 
                    />}
                <br />
            </>
        )
    }

    const emptyDocument = () => {
        return (
            <div className='row' style={{marginLeft: "5px"}}>
               <span>{"NO FILE UPLOADED"}</span> 
            </div>
        )
    }

    const documentsSectionComponent = (key,item) => { 
        let formsComponents = []
        let noticesComponents = []

        let formsReview = "", noticesReview = ""

        item.forEach((d) => {
            let component = null

            if("filename" in d) { 
                component = documentComponent(d)
            } else { 
                component = emptyDocument()
            }

            if(d.type === CONST.DOCUMENT_TYPE_FORMS_AGREEMENTS) { 
                formsComponents.push(component)
                formsReview = d.review
            } else if(d.type === CONST.DOCUMENT_TYPE_NOTICES_LETTERS) {
                noticesReview = d.review 
                noticesComponents.push(component)
            }
        })
        
        return (
            <>
                <ReviewForm
                    data={{"Forms and agreements" : formsComponents}}
                    review={formsReview}
                    isReadOnly={isReadOnly}
                    onStatusChange={(updatedItem) => {
                        // let reviewedDocs = item.map(d => {
                        //     if(d.type === CONST.DOCUMENT_TYPE_FORMS_AGREEMENTS) { 
                        //         return {
                        //             ...d,
                        //             review : updatedItem.review
                        //         }
                        //     } else { 
                        //         return d
                        //     }
                        // })

                        // onReviewStatusChange(sectionKey,reviewedDocs)
                    }}
                />
                <SubSeparator />
                <ReviewForm
                    data={{"Notices and letters" : noticesComponents}}
                    review={noticesReview}
                    isReadOnly={isReadOnly}
                    showConfirmation={true}
                    confirmationMessage={`Is the ${sectionNameMappings[key]?.title} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        // let reviewedDocs = item.map(d => {
                        //     if(d.type === CONST.DOCUMENT_TYPE_NOTICES_LETTERS) { 
                        //         return {
                        //             ...d,
                        //             review : updatedItem.review
                        //         }
                        //     } else { 
                        //         return d
                        //     }
                        // })
                        // onReviewStatusChange(sectionKey,reviewedDocs)
                    }}
                />
            </>
        )
    }

    const suretyBondSectionComponent = (key,item) => { 
        let components = []
        let suretyBondReview

        item.forEach((d) => {
            if(d.type === CONST.DOCUMENT_TYPE_SURETY_BONDS) { 
                let component = null

                if("filename" in d) { 
                    component = documentComponent(d)
                } else { 
                    component = emptyDocument()
                }

                if(component) {
                    components.push(component)
                    suretyBondReview = d.review
                }
            }
        })
        
        return (
            <>
                <ReviewForm
                    data={{"Supporting documents" : components}}
                    review={suretyBondReview}
                    isReadOnly={isReadOnly}
                    showConfirmation={true}
                    confirmationMessage={`Is the ${sectionNameMappings[key]?.title} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        // let reviewedDocs = item.map(d => {
                        //     if(d.type === CONST.DOCUMENT_TYPE_FORMS_AGREEMENTS) { 
                        //         return {
                        //             ...d,
                        //             review : updatedItem.review
                        //         }
                        //     } else { 
                        //         return d
                        //     }
                        // })

                        // onReviewStatusChange(sectionKey,reviewedDocs)
                    }}
                />
            </>
        )
    }
    
    const branchComponents = (sectionKey, item) => {
        const components = []
        const branchesAdded = []
        const branchesRenewed = []
        const branchesNotRenewed = []

        item?.forEach(branchApp => {
            if(branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                && branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD) {
                    branchesAdded.push(branchApp)
            } else if(branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                && branchApp.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
                    branchesNotRenewed.push(branchApp)
            } else if(branchApp.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
                && branchApp.applicationStatus === CONST.APPLICATION_STATUS_UNREAD) {
                    branchesRenewed.push(branchApp) 
            }
        })

        if(branchesAdded.length) {
            const additionalBranchData = parseAdditionalBranchesData(branchesAdded)
            components.push(
            <>
                <h4>Branches added :</h4>
                {additionalBranchData.map((app,index) => (
                    <>
                        <ReviewForm 
                            data={app}
                            review={null}
                            hideDecisionCheckbox={false} 
                            isReadOnly={isReadOnly}
                            showConfirmation={!branchesRenewed.length && !branchesNotRenewed.length}
                            confirmationMessage={`Is the ${sectionNameMappings[sectionKey]?.title} section complete and correct?`}
                            onStatusChange={(updatedItem) => {
                                // 
                            }}
                        />
                        {index < additionalBranchData.length - 1 ? <SubSeparator /> : null}
                    </>
                ))}
            </>)
        }

        if(branchesRenewed.length) {
            const renewedBranchesComponents = []
            branchesRenewed.forEach((branchApp, index) => {
                const renewedData = parseAdditionalBranchesData([branchApp])
                let archivedData = undefined

                const archiveAppIndex = branchArchiveApplications.findIndex(app => app.originalApplicationId === branchApp.id)
                if(archiveAppIndex !== -1) {
                    const archiveApp = branchArchiveApplications[archiveAppIndex]
                    archivedData = parseAdditionalBranchesData([archiveApp])
                } else {
                    archivedData = [{
                        "Branch name" : "",
                        "Branch address" : "",
                        "Responsible agent" : "",
                        "Phone number" : "",
                        "Responsible agent email" : "", 
                        review : null
                    }]
                }

                const dataChanges = []

                for (const key in renewedData[0]) {
                    
                    if(key === "review") 
                        continue

                    dataChanges.push({
                        parameterName: key,
                        changeFrom : archivedData?.[0][key] ?? "",
                        changeTo : renewedData?.[0][key] ?? ""
                    })
                }

                renewedBranchesComponents.push(
                <>
                    <BLTChangeReviewForm 
                        data={dataChanges}
                        reviewKey={sectionKey}
                        review={null}
                        showChangesTitle={index === 0}
                        showConfirmation={!branchesNotRenewed.length}
                        confirmationMessage={`Is the ${sectionNameMappings[sectionKey]?.title} section complete and correct?`}
                        onStatusChange={update => {
                            // setReviewStatus(Object.assign(reviewStatus, 
                            //     Object.defineProperty({}, key, {value:update.review, writable: true, enumerable: true})
                            // ))
                        }}
                    />
                    {(index < branchesRenewed.length - 1) ? <SubSeparator /> : null}
                </>)
            })

            if(components.length > 0) {
                components.push(<SubSeparator />)
            }

            components.push(
            <>
                <h4>Branches renewed :</h4>
                {renewedBranchesComponents}
            </>)
        }

        if(branchesNotRenewed.length) {

            if(components.length > 0) {
                components.push(<SubSeparator />)
            }

            const notRenewedBranches = parseAdditionalBranchesData(branchesNotRenewed)

            components.push(
            <>
                <h4>Branches not renewed :</h4>
                {notRenewedBranches.map((app, index) => (
                    <>
                    <ReviewForm 
                        data={app}
                        review={null}
                        hideDecisionCheckbox={false} 
                        isReadOnly={isReadOnly}
                        showConfirmation={true}
                        confirmationMessage={`Is the ${sectionNameMappings[sectionKey]?.title} section complete and correct?`}
                        onStatusChange={(updatedItem) => {
                            // 
                        }}
                    />
                    {index < notRenewedBranches.length - 1 ? <SubSeparator /> : null}
                    </>
                ))}
            </>)
        }

        if(!components.length) {
            components.push(
                <ReviewForm 
                    data={[]}
                    review={null}
                    hideDecisionCheckbox={true} 
                    isReadOnly={isReadOnly}
                    showConfirmation={true}
                    confirmationMessage={`Is the ${sectionNameMappings[sectionKey]?.title} section complete and correct?`}
                    onStatusChange={(updatedItem) => {
                        // 
                    }}
                />
            )
        }

        return components;
    }

    useEffect(() => {
        if(!queueItem) {
            dispatch(fetchApplicationWithId(parseInt(qItemId)))
            .then(data => {
                dispatch(setChangeReviewQueueItem(data))
            })
        }
    }, [dispatch,queueItem,qItemId])

    const individualReviewItem =  (key, change, index) => {
        switch(key) {
            case 'attachments' : 
                return documentsSectionComponent(key,change)
            case 'suretyBond' : 
                return suretyBondSectionComponent(key, change)
            case 'internalNotes' : 
                return internalNotesSectionComponents()
            case 'branches' : 
                return branchComponents(key, change)
            default :
                if(sectionNameMappings[key]?.type === "diff_review") {
                    return <BLTChangeReviewForm 
                                data={change}
                                reviewKey={key}
                                review={null}
                                showChangesTitle={index === 0}
                                showConfirmation={true}
                                confirmationMessage={`Is the ${sectionNameMappings[key]?.title} section complete and correct?`}
                                onStatusChange={update => {
                                    onReviewStatusChange(key, update)
                                }}
                            />
                    
                } else {
                    if(Array.isArray(change)) {
                        return change.map((c, index) => (
                                <>
                                    <ReviewForm
                                        data={c}
                                        review={false}
                                        hideDecisionCheckbox={false} 
                                        isReadOnly={isReadOnly}
                                        showConfirmation={true}
                                        confirmationMessage={`Is the ${sectionNameMappings[key]?.title} section complete and correct?`}
                                        onStatusChange={(updatedItem) => {
                                            // onReviewStatusChange(key, updatedItem, reviewItemIndex)
                                        }}
                                    />
                                    {(index < change.length - 1) && <SubSeparator />}
                                </>
                                ))
                                
                    } else {
                        return <ReviewForm
                                    data={change}
                                    review={false}
                                    hideDecisionCheckbox={false} 
                                    isReadOnly={isReadOnly}
                                    showConfirmation={true}
                                    confirmationMessage={`Is the ${sectionNameMappings[key]?.title} section complete and correct?`}
                                    onStatusChange={(updatedItem) => {
                                        // onReviewStatusChange(key, updatedItem, reviewItemIndex)
                                    }}
                                />
                    }
                }
        }

    }

    const decisionSectionComponent = () => {
        const isReadOnly = false
        const moveToNextScreen = () => {
            let nextUrl = CONST.ROUTE_PATH.BLT_DECISION_SUMMARY
            dispatch(push(nextUrl.replace(':status', applicationDecision.toLowerCase())))
        }

        const handleApplicationStatusChange = (e) => {
            setApplicationDecision(e.target.value)
            // onReviewStatusChange(sectionKey, {
            //     ...item,
            //     ...{review : "complete"}
            // })
        }

        const handleContinue = () => {
            if(!validateCompleteness()) {
                setShowValidationError(true)
                return
            }

            setShowValidationError(false)
            
            let applicationType = applicationTypeFromLicenceSubType(queueItem.licencingSubType)
            let primaryBusinessApplicationId = null
                
            if(isAgencyTypeApplication(queueItem)) 
            {
                if(applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) { 
                     /* If "Cancelled by client" seelected from adjudication screen then It goes to APPLICATION_STATUS_WITHDRAWN_APPROVED
            instead of APPLICATION_STATUS_WITHDRAWN_BY_CLIENT (To avoid confirm button in pending queue list) */
                    dispatch(setAgencyApplicationStatus(CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED))
                    dispatch(setAgencyApplicationLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
                }
                else {
                    dispatch(setAgencyApplicationStatus(applicationDecision))
                }

                dispatch(setAgencyApplicationLocked(null))

                if(applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) { 
                    dispatch(setAgencyApplicationLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
                }
            } else if(isIndividualTypeApplication(queueItem)) 
            { 
                if(applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) { 
                    dispatch(setCurrentAgentApplicationStatus(CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED))
                    dispatch(setCurrentAgentLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT))
                }
                else {
                    dispatch(setCurrentAgentApplicationStatus(applicationDecision))
                }

                dispatch(setCurrentAgentApplicationLocked(null))

                if(applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) { 
                    dispatch(setCurrentAgentLicenceStatus(CONST.LICENCE_STATUS_ACTIVE))
                }

                primaryBusinessApplicationId = queueItem.businessApplicationId
            }

            dispatch(saveBusinessLicenceApplicationData(applicationType, CONST.APPLICATION_MODE_NEW))
                .then(data => {

                    if(queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
                        || queueItem.licencingSubType === CONST.LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) 
                    {
                        const promiseArray = [];
                        // the renewal application needs to be automatically be the same status as 
                        // agency application.
                        promiseArray.push(sendRenewedIndividualApplicationStatus(applicationDecision, primaryBusinessApplicationId));

                        // for a newly submitted : 
                        // 1. individual application -> the status will be UNREAD.
                        // 2. branch application -> the status will be same as agency application status.
                        const targetStatusForBranch = applicationDecision
                        let targetStatusForIndividualApplications = applicationDecision

                        if(applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) { 
                            targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_UNREAD
                        } else if(applicationDecision === CONST.APPLICATION_STATUS_PENDING) {
                            targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_PENDING_AGENCY
                        }

                        promiseArray.push(
                            dispatch(sendNewIndividualApplicationStatus(
                                targetStatusForBranch,targetStatusForIndividualApplications)
                            )
                        );

                        Promise.all(promiseArray)
                        .then(() => {
                            moveToNextScreen();
                        })

                        // send the renewed branch applications status to application decision
                        // dispatch(sendRenewedIndividualApplicationStatus(applicationDecision, primaryBusinessApplicationId))
                        //     .then(() => {
                        //         // send the new application status to UNREAD
                        //         let targetStatusForIndividualApplications = applicationDecision

                        //         if(applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED) { 
                        //             targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_UNREAD
                        //         } else if(applicationDecision === CONST.APPLICATION_STATUS_PENDING) {
                        //             targetStatusForIndividualApplications = CONST.APPLICATION_STATUS_PENDING_AGENCY
                        //         }

                        //         dispatch(sendNewIndividualApplicationStatus(
                        //             applicationDecision,targetStatusForIndividualApplications)
                        //         ).then(() => {
                        //             moveToNextScreen()
                        //         })
                        //     })
                    } else { 
                        moveToNextScreen()
                    }
                })
                .catch(error => {
                    // TODO : handle errors
                    setApplicationSaveError(true)
                    console.error(error)
                })
        }

        return (
            <>
            <div className="decisionFormItem">
                <div className="decisionFormItemInfo bottomMarginNormal">
                    Based on the information in this application, select a new application status
                </div>
                <div className="bltreview-decision-form">
                    <fieldset className="ns-fieldset">
                        <div className={"ns-radios ns-radios--small"}>
                            <div key={"approve-decision"} className="ns-radios__item">
                                <input 
                                    className="ns-radios__input"
                                    key={"approve-decision-input"}
                                    type={"radio"} 
                                    value={CONST.APPLICATION_STATUS_APPROVED_ISSUED} 
                                    checked={applicationDecision === CONST.APPLICATION_STATUS_APPROVED_ISSUED}
                                    onChange={handleApplicationStatusChange}
                                    id={"bltreview-decision-form-approve-input"} 
                                    name={"bltreview-decision-form-approve-input"}
                                    disabled={isReadOnly}
                                />
                                <label 
                                    key={"approve-decision-label"}
                                    id={"bltreview-decision-form-approve-label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltreview-decision-form-approve-input"}>
                                        <div className="licence-status-approved">
                                            <i className="fa fa-check-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Approved</span>
                                        <span className="bltReviewDecisionInfo">Application is complete and client is eligible for licensing</span>
                                </label>
                            </div>
                            <div key={"pending-decision"} className="ns-radios__item">
                                <input 
                                    className="ns-radios__input"
                                    key={"pending-decision-input"}
                                    type={"radio"} 
                                    value={CONST.APPLICATION_STATUS_PENDING} 
                                    checked={applicationDecision === CONST.APPLICATION_STATUS_PENDING}
                                    onChange={handleApplicationStatusChange}
                                    id={"bltreview-decision-form-pending-input"} 
                                    name={"bltreview-decision-form-pending-input"}
                                    disabled={isReadOnly} 
                                />
                                <label 
                                    key={"pending-decision-label"}
                                    id={"bltreview-decision-form-pending--label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltreview-decision-form-pending-input"}>
                                        <div className="licence-status-pending">
                                            <i className="fa fa-clock-o fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Pending</span>
                                        <span className="bltReviewDecisionInfo">Application is incomplete and client needs to provide additional details before they're eligible for licensing</span>
                                </label>
                            </div>
                            <div key={"deny-decision"} className="ns-radios__item">
                                <input 
                                    className="ns-radios__input"
                                    key={"deny-decision-input"}
                                    type={"radio"} 
                                    value={CONST.APPLICATION_STATUS_DENIED} 
                                    checked={applicationDecision === CONST.APPLICATION_STATUS_DENIED}
                                    onChange={handleApplicationStatusChange}
                                    id={"bltreview-decision-form-denied-input"} 
                                    name={"bltreview-decision-form-denied-input"} 
                                    disabled={isReadOnly}
                                />
                                <label 
                                    key={"deny-decision-label"}
                                    id={"bltreview-decision-form-denied--label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltreview-decision-form-denied-input"}>
                                        <div className="licence-status-denied">
                                            <i className="fa fa-times-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Denied</span>
                                        <span className="bltReviewDecisionInfo">Application doesn't meet requirements and client is ineligible for licensing</span>
                                </label>
                            </div>
                            <div key={"withdrawn-decision"} className="ns-radios__item">
                                <input 
                                    className="ns-radios__input"
                                    key={"withdrawn-decision-input"}
                                    type={"radio"} 
                                    value={CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT} 
                                    checked={applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT}
                                    onChange={handleApplicationStatusChange}
                                    id={"bltreview-decision-form-withdrawn-input"} 
                                    name={"bltreview-decision-form-withdrawn-input"} 
                                    disabled={isReadOnly}
                                />
                                <label 
                                    key={"withdrawn-decision-label"}
                                    id={"bltreview-decision-form-withdrawn--label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltreview-decision-form-withdrawn-input"}>
                                        <div className="licence-status-withdrawn">
                                            <i className="fa fa-exclamation-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Cancelled by client</span>
                                        <span className="bltReviewDecisionInfo">Client no longer wants to proceed with application.</span>
                                </label>
                            </div>
                            <div key={"withdrawn-approved-decision"} className="ns-radios__item">
                                <input 
                                    className="ns-radios__input"
                                    key={"withdrawn-approved-decision-input"}
                                    type={"radio"} 
                                    value={CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED} 
                                    checked={applicationDecision === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED}
                                    onChange={handleApplicationStatusChange}
                                    id={"bltreview-decision-form-withdrawn-approved-input"} 
                                    name={"bltreview-decision-form-withdrawn-approved-input"} 
                                    disabled={isReadOnly}
                                />
                                <label 
                                    key={"withdrawn-approved-decision-label"}
                                    id={"bltreview-decision-form-withdrawn-approved--label"}
                                    className="ns-radios__label"
                                    htmlFor={"bltreview-decision-form-withdrawn-approved-input"}>
                                        <div className="licence-status-withdrawn">
                                            <i className="fa fa-exclamation-circle fa-lg"></i>
                                        </div>
                                        <span className="ns-label-span bltReviewDecisionLabel">Cancelled</span>
                                        <span className="bltReviewDecisionInfo">Withdrawn approved by the business licensing team.</span>
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </div>
                {!isReadOnly && 
                (<>
                    <div className={"decisionFormItemButton bottomMarginNormal" + ((showValidationError || applicationSaveError) ? " has-error" : "")}>
                        <Button
                            id="decision-form-item-button"
                            buttonType="regular_primary" 
                            text="Continue"
                            onClick={handleContinue}
                        />
                        {(showValidationError || applicationSaveError) && ErrorMark()}
                        {(showValidationError || applicationSaveError) && <div className="help-blocked">
                            {showValidationError ? validationError : (applicationSaveError ? "Could not save application." : "")}
                        </div>}
                    </div>
                    <div className="decisionFormItemInfo bottomMarginNormal">
                        Provide additional information to the client about their licence status in the next step 
                    </div>
                </>)}
            </div>
            </>
        )
    }

    const changeItemsComponent = () => {

        let components = []
        let index = 0;

        for (const key in changeData) { 
            const change = changeData[key]

            components.push(
                <li className="timeline-item col-md-12 col-lg-12">
                    <div className={["col-lg-12","col-md-12","col-xs-12","step-content"].join(" ")}>
                        <span className={["step-counter","step-counter-circle"].join(" ")}>
                            {index + 1}
                        </span>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <h3>{sectionNameMappings[key]?.title ?? key}</h3>
                            <button 
                                id="section-toggle-button"
                                className="btn btn-primary" 
                                data-toggle="collapse" 
                                data-target={"#" + key}
                                aria-expanded="false" 
                                aria-controls={key}
                                onClick={() => { expandSection(key, !sectionShown[key]) } }
                            >
                                {sectionShown[key] ? "Hide" : "Show"}
                            </button>
                        </div>
                        <div className="collapse" id={key}>
                            {individualReviewItem(key, change, index)}
                        </div>

                        <MainSeparator />

                    </div>
                </li>
            )

            index++
        }

        components.push(
            <li className="timeline-item col-md-12 col-lg-12">
                <div className={["col-lg-12","col-md-12","col-xs-12","step-content","step-content-no-border"].join(" ")}>
                    <span className={["step-counter","step-counter-circle"].join(" ")}>
                        {index + 1}
                    </span>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <h3>Decision</h3>
                    </div>

                    <div className="col-lg-12">
                        {decisionSectionComponent()}
                    </div>
                </div>
            </li>
        )
        return components
    }

    const validateCompleteness = () => {
        setValidationError("Validation incomplete")
        return false
    }

    return (
        <>
            <BLTNavigationTop />
            <div className="container">
                <BLTScreenNavigation {...props} />
                <div className="row bottomMarginMedium">
                    <h1>{mainTitle(queueItem)}</h1>
                </div>
                <div className="row">
                    <div className="col-lg-10">
                        <div className="row">
                            <span className="bltChangeReview-businessName">{mediumTitle(queueItem)}</span>
                        </div>
                        <div className="row">
                            <span className="bltChangeReview-legalName">{legalNameTitle(queueItem)}</span>
                        </div>
                        <div className="row">
                            <span className="bltChangeReview-contactPersonName">{subTitle(queueItem)}</span>
                        </div>
                    </div>
                </div>

                <div className="timeline row topMarginMedium">
                    <div className="col-lg-12 bltChangeReviewList">
                        <ol>
                            {changeItemsComponent()}
                        </ol>
                    </div>
                </div>

                <DocumentViewer 
                    fileData={documentViewerDocument}
                    isOpen={openDocumentViewer}
                    fileName={selectedFile?.filename}
                    handleClose={() => setOpenDocumentViewer(false)}
                />
                
            </div>
        </>
    )
}

export default connect(bltChangeReviewSelect)(BLTChangeReview);
